export default __webpack_public_path__ + "static/media/boreal_wolfs_broken_fang.739f2a60.png";